import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
  useCallback,
  
} from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Paper,
  ToggleButtonGroup,
  ToggleButton,
  InputAdornment,
  useTheme,
  useMediaQuery,
  Grid,
  MenuItem,
  Menu,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Tooltip,
  Alert,

} from "@mui/material";
import { alpha } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SellIcon from "@mui/icons-material/Sell";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';

import { useOrderForm, calcMargin } from "../../hooks/useOrderForm";
import octopusInstance from "../../services/octopus/octopusInstance";
import { getExchangeCode } from "../../services/exchanges";

import { useSelector, useDispatch } from "react-redux";
import { addMarketWatchInstrumentAction, deleteMarketWatchInstrumentAction } from "../../store/actions/watchlist";
import { fetchFundsView } from "../../store/actions/funds";
import { enqueueSnackbar } from "notistack";
import { DEPOSIT_URL } from "../../utils/constant";
import useBalance from "../Portfolio/Positions/useBalance";
import { updateCalculatedFunds } from "../../store/actionCreators/fundsActions";
import { usePendingOrdersInOrderWindow } from "../../hooks/usePendingOrdersInOrderWindow";
import PendingOrdersSection from "./PendingOrdersSection";

const DraggablePaper = forwardRef((props, ref) => {
  return (
    <Draggable
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={ref} />
    </Draggable>
  );
});

const OrderWindow = React.memo((props) => {
  const theme = useTheme();
  // const {formattedWatchlists} = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const positionData = useSelector((state) => state.portfolio.arrPositionsUpdateData);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isSquareOff, setIsSquareOff] = useState(false);
  const initialLTP = useRef(null);
  const currentLTP = useRef(null);
  const isFirstMessage = useRef(true);
  const [requiredMargin, setRequiredMargin] = useState(0);
  const userSettings = useSelector((state) => {
    const settings = state.profile.userSettings;
    return settings;
  });
  const { userData } = useSelector(state => state.profile);
  // Get funds data using the global useBalance hook
  const balanceData = useBalance();
  const [loadingFunds, setLoadingFunds] = useState(false);

  const [marketData, setMarketData] = useState({
    ltp: props.ltp,
    bestBid: props.bestBid,
    bestAsk: props.bestAsk,
  });

 
  // const navigatedToPayIn = useSelector((state) => state.funds.navigatedToPayIn);

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileDialogOpen, setMobileDialogOpen] = useState(false);

  // Get available cash from useBalance hook
  const availableMargin = balanceData.availableCash;
  const isLowMargin = availableMargin < requiredMargin; 
  // Handle refresh funds
  const handleRefreshFunds = () => {
    setLoadingFunds(true);
    dispatch(updateCalculatedFunds());
    setTimeout(() => setLoadingFunds(false), 1000); // Ensure loading state is visible for at least 1 second
  };

  // Handle add funds click
  const handleAddFundsClick = () => {
      if (!userData?.phone_number) {
        enqueueSnackbar('User phone number not available', { variant: 'error' });
      return;
    }
    dispatch({
      type: 'SET_NAVIGATED_TO_PAYIN',
      payload: true
    });
    navigate('/payin',{replace:true});
    // window.open(`${DEPOSIT_URL}&phone=${userData.phone_number}`, '_blank');
  };



  // useEffect(() => {
  //   // Fetch funds when component mounts
  //   dispatch(fetchFundsView());
  // }, [dispatch]);

  useEffect(() => {
    if (props.open) {
      isFirstMessage.current = true;
      initialLTP.current = null;
      currentLTP.current = null;
    }
  }, [props.open]);

  const handleWebSocketMessage = useCallback(({ msg }) => {
    if (isFirstMessage.current && msg.lastTradedPrice) {
      initialLTP.current = msg.lastTradedPrice;
      isFirstMessage.current = false;
    }
    currentLTP.current = msg.lastTradedPrice || currentLTP.current;

    setMarketData((prev) => {
      const newData = {
        ltp: msg.lastTradedPrice || prev.ltp,
        bestBid: msg.bestBidPrice || prev.bestBid,
        bestAsk: msg.bestAskPrice || prev.bestAsk,
      };

      if (JSON.stringify(prev) === JSON.stringify(newData)) {
        return prev;
      }
      return newData;
    });
  }, []);

  useEffect(() => {
    if (!props.open || !props.token || !props.exchange) return;
    console.log('haha',props);
    const handler = octopusInstance.wsHandler({
      messageType: "DetailMarketDataMessage",
      subscriptionLocation: `orderwindow-${props.token}`,
      payload: {
        exchangeCode: getExchangeCode(props.exchange),
        instrumentToken: props.token,
      },
    });

    handler.subscribe(handleWebSocketMessage);
    return () => handler.unsubscribe();
  }, [props.open, props.token, props.exchange, handleWebSocketMessage]);

  const {
    orderType,
    quantity,
    price,
    loading,
    product,
    is_modify,
    priceError,
    triggerError,
    quantityError,
    orderSide,
    orderDetails,
    setOrderType,
    setProduct,
    handleTypeChange,
    handlePriceChange,
    handleTriggerKeyDown,
    handleTriggerChange,
    handleQuantityChange,
    handleQuantityKeyDown,
    handlePriceKeyDown,
    handleSubmit,
    handleModify,
    hasMatchingPosition,
    isDisabled,
    getProductOptions,
    radioTypeOptions,
    hideMargin,
    strike_price,
    minimumQtyRequired,
    minimumOrderValue,
    PRIME_SETTINGS,
    isSquareOffOrder,
    existingPositionQty
  } = useOrderForm({
    ...props,
    ltp: initialLTP.current,
    bestBid: marketData.bestBid,
    bestAsk: marketData.bestAsk,
  });

  // Use custom hook for pending orders (after useOrderForm to access orderSide, product, etc.)
  const pendingOrders = usePendingOrdersInOrderWindow({
    token: props.token,
    exchange: props.exchange,
    isOpen: props.open,
    orderSide: orderSide,
    product: product,
    positionData: positionData,
    hasMatchingPosition: hasMatchingPosition
  });
  console.log("pendingOrders",pendingOrders);

  // Update isSquareOff state based on all square-off detection methods
  useEffect(() => {
    // Method 1: Direct square-off from props
    const isDirectSquareOff = props.isSquareOff || false;
    
    // Method 2: Square-off detected from useOrderForm hook
    const isPositionBasedSquareOff = isSquareOffOrder;
    
    // Method 3: Manual position check for additional validation
    let isManualSquareOff = false;
    if (!isDirectSquareOff && !isPositionBasedSquareOff && positionData && positionData.length > 0) {
      const matchingPosition = positionData.find(position => 
        (String(position.token) === String(props.token) ||
         String(position.instrument_token) === String(props.token)) &&
        position.net_quantity !== 0 && 
        position.product === product
      );
      
      if (matchingPosition) {
        const netQuantity = Number(matchingPosition.net_quantity) || 0;
        const positionSide = netQuantity < 0 ? "SELL" : "BUY";
        const numericQty = parseInt(quantity) || 0;
        
        // If this is a square-off order (opposite direction of position)
        if ((positionSide === "BUY" && orderSide === "SELL") || 
            (positionSide === "SELL" && orderSide === "BUY")) {
          
          // If entered quantity is less than or equal to position quantity, it's a valid square-off
          if (numericQty <= Math.abs(netQuantity)) {
            isManualSquareOff = true;
          }
        }
      }
    }
    
    // Set the final square-off state
    const finalSquareOffState = isDirectSquareOff || isPositionBasedSquareOff || isManualSquareOff;
    
    if (finalSquareOffState !== isSquareOff) {
      console.log("Updating isSquareOff state:", {
        from: isSquareOff,
        to: finalSquareOffState,
        reasons: {
          isDirectSquareOff,
          isPositionBasedSquareOff,
          isManualSquareOff
        }
      });
      setIsSquareOff(finalSquareOffState);
    }
  }, [props.isSquareOff, isSquareOffOrder, positionData, props.token, product, orderSide, quantity, isSquareOff]);

  // Flag to check if quantity meets minimum requirements
  const [minQuantityError, setMinQuantityError] = useState(false);

  // Update the minQuantityError calculation to respect square-off operations
  useEffect(() => {
    // If this is a square-off operation, bypass minimum quantity validation
    if (isSquareOff) {
      console.log("OrderWindow: Square-off operation detected - no minimum quantity required");
      setMinQuantityError(false);
      return;
    }
    
    // Normal validation logic for non-square-off orders
    if (minimumQtyRequired > 0 && parseInt(quantity) < minimumQtyRequired) {
      // For market orders, we've already calculated minimum quantity based on market price
      // For limit orders, check only if price is set
      if (orderType === "MARKET" || orderType === "STOPLOSSMARKET" || parseFloat(price) > 0) {
        setMinQuantityError(true);
      } else {
        setMinQuantityError(false);
      }
    } else {
      setMinQuantityError(false);
    }
  }, [quantity, minimumQtyRequired, price, orderType, isSquareOff, orderSide, product]);

  // Cache previous values to avoid unnecessary margin calculations
  const marginCalculationCache = useRef({
    lastInputs: null,
    lastResult: 0
  });
  
  // Check if document is visible
  const isDocumentVisible = () => document.visibilityState === 'visible';

  useEffect(() => {
    let marginPrice;
    
    // Skip calculation if document is not visible
    if (!isDocumentVisible() || !quantity || !product || !props.exchange) {
      return;
    }
    
    if (orderType === "LIMIT" || orderType === "SL") {
      marginPrice = price;
    } else {
      marginPrice =
        orderSide === "BUY" ? marketData.bestAsk : marketData.bestBid;
    }
    
    // Create a key from all inputs that affect margin calculation
    const inputKey = JSON.stringify({
      quantity,
      product,
      orderSide,
      marginPrice,
      exchange: props.exchange,
      token: props.token,
      instrumentName: props.payload?.instrument_name,
      raw_board_lot_quantity: props.payload?.raw_board_lot_quantity
    });
    
    // Check if we've already calculated this exact margin
    if (marginCalculationCache.current.lastInputs === inputKey) {
      console.log("Using cached margin calculation");
      return; // No need to recalculate
    }
    
    const requiredMarginObject = hasMatchingPosition(positionData, props.token, orderSide, quantity, product);
    console.log("requiredMarginObject",requiredMarginObject);
    // Calculate margin only when inputs have changed
    const margin = calcMargin({
      order_config: userSettings.order_margin,
      exchange: props.exchange,
      orderSide,
      product,
      price: parseFloat(marginPrice || 0),
      strike_price: strike_price,
      qty: Number(requiredMarginObject?.netQuantity),
      instrumentName: props.payload?.instrument_name,
      raw_board_lot_quantity: props.payload?.raw_board_lot_quantity
    });
    setRequiredMargin(requiredMarginObject?.hideMargin);
    // Store result in cache
    marginCalculationCache.current = {
      lastInputs: inputKey,
      lastResult: margin
    };
    
    // Update the state with the new margin
    if (requiredMarginObject?.hideMargin) {
      setRequiredMargin(0);
    } else {
      setRequiredMargin(margin);
    }
  }, [
    quantity,
    product,
    orderSide,
    orderType,
    price,
    strike_price,
    marketData,
    positionData,
    props.exchange,
    props.token,
    props.payload
  ]);
  
  // Clear cache when visibility changes to ensure fresh data when tab becomes visible
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // Reset cache when tab becomes visible
        marginCalculationCache.current = {
          lastInputs: null,
          lastResult: 0
        };
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const handleClose = useCallback(
    (e) => {
      if (e) {
        e.stopPropagation();
      }
      if (props.onClose) {
        props.onClose();
      }
    },
    [props.onClose]
  );

  // Add a function to handle adding instruments to marketwatch
  const handleAddToMarketwatch = useCallback((watchlist, index) => {
    // Check if watchlist is full
    if (watchlist.instruments && watchlist.instruments.length >= 20) {
      enqueueSnackbar(`${watchlist.name} is full (max 20 instruments)`, {
        variant: "warning",
      });
      return;
    }
    
    // Create payload
    const payload = {
      mw_id: watchlist.id,
      exchange: props.exchange,
      trading_symbol: props.trading_symbol,
      token: props.token.toString(),
      execution:"NORMAL",
    };
    
    
    // Dispatch action with correct parameters
    dispatch(addMarketWatchInstrumentAction(index, payload))
      .then(response => {
        // console.log("Add to marketwatch response:", response);
        if (response && response.status === "success") {
          enqueueSnackbar(`${props.display_name || props.trading_symbol} added to ${watchlist.name}`, {
            variant: "success",
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar(response?.message || "Failed to add to marketwatch", {
            variant: "error",
            autoHideDuration: 1000,
          });
        }
      });
  }, [dispatch, props.display_name, props.exchange, props.execution, props.token, props.trading_symbol]);

  // Add a function to handle removing instruments from marketwatch
  const handleRemoveFromMarketwatch = useCallback((watchlist, index) => {
    const payload = {
      marketWatchId: watchlist.id,
      exchange: props.exchange,
      token: props.token,
      symbolName: props.trading_symbol,
      execution: props.execution || "REGULAR",
    };
    
    dispatch(deleteMarketWatchInstrumentAction(
      payload,
      index,
      props.formattedWatchlists,
      { token: props.token, exchange: props.exchange, trading_symbol: props.trading_symbol }
    ))
      .then(response => {
        if (response && response.status === "success") {
          enqueueSnackbar(`${props.display_name || props.trading_symbol} removed from ${watchlist.name}`, {
            variant: "success",
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar(response?.message || "Failed to remove from marketwatch", {
            variant: "error",
            autoHideDuration: 1000,
          });
        }
      });
  }, [dispatch, props.display_name, props.exchange, props.execution, props.formattedWatchlists, props.token, props.trading_symbol]);

  // Show warning message if funds are insufficient
  const isFundsInsufficient = availableMargin < requiredMargin && requiredMargin > 0;

  // Format currency value
  const formatCurrency = (value) => {
    if (!value) return "₹0";
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return formatter.format(value);
  };

  // Update isDisabled to include minQuantityError and pending orders for square-off
  const isOrderDisabled = isSquareOff ? 
    // For square-off operations, disable if there are pending orders, funds are insufficient, or price/trigger errors
    (isDisabled && !quantityError && !minQuantityError) || 
    isFundsInsufficient || 
    (pendingOrders.instrumentPendingOrders && pendingOrders.instrumentPendingOrders.length > 0) : 
    // Normal case: full validation
    isDisabled || 
    minQuantityError || 
    isFundsInsufficient;

  // Add console logs to detect square-off mode
  useEffect(() => {
    // Log on component mount to confirm square-off state
    console.log("OrderWindow square-off state:", {
      isSquareOff,
      propsIsSquareOff: props.isSquareOff,
      minQuantityError,
      quantity,
      minimumQtyRequired
    });
    
    // For square-off operations, ensure error is cleared
    if (isSquareOff) {
      console.log("OrderWindow: Square-off operation detected, clearing minimum quantity error");
      setMinQuantityError(false);
    }
  }, [isSquareOff, props.isSquareOff, minQuantityError, quantity, minimumQtyRequired]);

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      PaperComponent={isMobile ? Paper : DraggablePaper}
      aria-labelledby="draggable-dialog-title"
      onClick={(e) => e.stopPropagation()}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
      keepMounted
      onMouseLeave={(e) => e.stopPropagation()}
      onBlur={(e) => e.stopPropagation()}
    >
      <DialogTitle
        className={!isMobile ? "draggable-dialog-title" : undefined}
        sx={{
          backgroundColor:
            orderSide === "BUY"
              ? theme.palette.buy.background
              : theme.palette.sell.background,
          background:
            orderSide === "BUY"
              ? `linear-gradient(135deg, ${theme.palette.buy.background} 0%, ${theme.palette.buy.light} 100%)`
              : `linear-gradient(135deg, ${theme.palette.sell.background} 0%, ${theme.palette.sell.light} 100%)`,
          color: theme.palette.common.white,
          cursor: !isMobile ? "move" : "default",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: isMobile ? 1.5 : 2,

          boxShadow: theme.shadows[4],
          transition: "background-color 0.3s ease",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ToggleButtonGroup
            value={orderSide}
            exclusive
            onChange={handleTypeChange}
            size={isMobile ? "small" : "medium"}
            sx={{
              backgroundColor:
                orderSide === "BUY"
                  ? theme.palette.buy.background
                  : theme.palette.sell.background,
              padding: "2px",
              borderRadius: "12px",
              boxShadow: theme.shadows[2],
            }}
          >
            <ToggleButton
              value="BUY"
              disabled={props.is_modify && props.type === "SELL"}
              sx={{
                color: theme.palette.text.primary,
                borderColor: "transparent",
                backgroundColor:
                  orderSide === "BUY"
                    ? theme.palette.buy.background
                    : "transparent",
                "&.Mui-selected": {
                  backgroundColor: theme.palette.buy.background,
                  color: theme.palette.primary.contrastText,
                  fontWeight: "bold",
                  boxShadow: theme.shadows[4],
                },
                "&:hover": {
                  backgroundColor: theme.palette.buy.background,
                  opacity: 0.9,
                },
                minWidth: isMobile ? "60px" : "70px",
                px: isMobile ? 1 : 2,
                borderRadius: "10px",
                transition: "all 0.3s ease",
                "&.Mui-disabled": {
                  opacity: 0.5,
                  color: alpha(theme.palette.primary.contrastText, 0.5),
                },
              }}
            >
              <ShoppingCartIcon
                sx={{
                  mr: 0.5,
                  fontSize: isMobile ? "1.2rem" : "1.4rem",
                  transition: "transform 0.2s ease",
                  "&:hover": { transform: "scale(1.1)" },
                }}
              />
              BUY
            </ToggleButton>
            <ToggleButton
              value="SELL"
              disabled={props.is_modify && props.type === "BUY"}
              sx={{
                color: theme.palette.text.primary,
                borderColor: "transparent",
                backgroundColor:
                  orderSide === "SELL"
                    ? theme.palette.sell.background
                    : "transparent",
                "&.Mui-selected": {
                  backgroundColor: theme.palette.sell.background,
                  color: theme.palette.primary.contrastText,
                  fontWeight: "bold",
                  boxShadow: theme.shadows[4],
                },
                "&:hover": {
                  backgroundColor: theme.palette.sell.background,
                  opacity: 0.9,
                },
                minWidth: isMobile ? "60px" : "70px",
                px: isMobile ? 1 : 2,
                borderRadius: "10px",
                transition: "all 0.3s ease",
                "&.Mui-disabled": {
                  opacity: 0.5,
                  color: alpha(theme.palette.primary.contrastText, 0.5),
                },
              }}
            >
              <SellIcon
                sx={{
                  mr: 0.5,
                  fontSize: isMobile ? "1.2rem" : "1.4rem",
                  transition: "transform 0.2s ease",
                  "&:hover": { transform: "scale(1.1)" },
                }}
              />
              SELL
            </ToggleButton>
          </ToggleButtonGroup>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant={isMobile ? "body1" : "subtitle1"}
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                ml: 1,
                textShadow: "0 1px 3px rgba(0,0,0,0.2)",
              }}
            >
              {props.display_name || props.symbol}
            </Typography>
          </Box>
        </Box>
        <IconButton
          size={isMobile ? "small" : "medium"}
          onClick={props.onClose}
          sx={{
            color: theme.palette.text.primary,
            transition: "transform 0.2s ease",
            "&:hover": {
              transform: "rotate(90deg)",
              backgroundColor: alpha(theme.palette.text.primary, 0.2),
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 2,
          px: isMobile ? 1.5 : 2,
          height: isMobile ? "100%" : "auto",
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.palette.background.default,
          overflow: isMobile ? "auto" : "visible",
          // Ensure scrolling works on mobile
          [theme.breakpoints.down('sm')]: {
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            maxHeight: "calc(100vh - 120px)", // Account for header and footer
          }
        }}
      >
        {/* Only show warning message if funds are insufficient */}
        {availableMargin < requiredMargin && requiredMargin > 0 && (
          <Alert
            severity="error"
            variant="filled"
            sx={{
              mb: 2,
              fontWeight: 500,
              borderRadius: 2,
              textAlign: isMobile ? 'center' : 'left',
              alignItems: 'center',
              justifyContent: isMobile ? 'center' : 'flex-start',
              fontSize: isMobile ? '1rem' : '0.95rem',
            }}
          >
            <strong>Insufficient funds:</strong> You do not have enough balance to place this order.
          </Alert>
        )}

        {/* Market Data Section */}
        <Paper
          elevation={0}
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 1,
            mb: 2,
            p: 1.5,
            backgroundColor: alpha(theme.palette.primary.main, 0.05),
            borderRadius: 2,
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            transition: "all 0.3s ease",
          }}
        >
          {[
            {
              label: "Best Bid",
              value: marketData.bestBid,
              color:
                theme.palette.mode === "dark"
                  ? "success.light"
                  : "success.main",
              labelColor: "success.main",
            },
            {
              label: "LTP",
              value: marketData.ltp?.toFixed(2),
              color: "primary.main",
              labelColor: "text.secondary",
            },
            {
              label: "Best Ask",
              value: marketData.bestAsk,
              color:
                theme.palette.mode === "dark" ? "error.light" : "error.main",
              labelColor: "error.main",
            },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 0.5,
                borderRadius: 1,
                transition: "all 0.3s ease",
                minHeight: '64px',
                backgroundColor: !item.value ? alpha(theme.palette.action.disabled, 0.1) : 'transparent',
                "&:hover": {
                  transform: item.value ? "scale(1.02)" : "none",
                  backgroundColor: item.value ? alpha(theme.palette.primary.main, 0.1) : alpha(theme.palette.action.disabled, 0.1),
                },
              }}
            >
              {item.value ? (
                <>
                  <Typography
                    variant="caption"
                    color={item.labelColor}
                    sx={{
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      mb: 0.5,
                    }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color={item.color}
                    sx={{
                      transition: "color 0.3s ease",
                      "&:hover": {
                        color:
                          theme.palette.mode === "dark"
                            ? theme.palette.text.primary
                            : theme.palette.text.secondary,
                      },
                    }}
                  >
                    ₹ {item.value}
                  </Typography>
                </>
              ) : (
                <Box sx={{ 
                  width: '60%', 
                  height: '8px', 
                  backgroundColor: alpha(theme.palette.action.disabled, 0.2),
                  borderRadius: '4px',
                }} />
              )}
            </Box>
          ))}
        </Paper>

        {/* Pending Orders Section */}
        {isSquareOff && !is_modify && (
          <Box 
            sx={{ 
              width: '100%',
              mb: 2,
              // Add some debug styling to ensure visibility
              [theme.breakpoints.down('sm')]: {
                border: '1px solid transparent', // Debug border
                borderRadius: 1,
                backgroundColor: 'background.paper',
                position: 'relative',
                zIndex: 1,
              }
            }}
          >
            {console.log('PendingOrdersSection rendering:', { 
              isSquareOff, 
              is_modify, 
              isMobile, 
              ordersCount: pendingOrders.instrumentPendingOrders?.length,
              orders: pendingOrders.instrumentPendingOrders 
            })}
            <PendingOrdersSection
              orders={pendingOrders.instrumentPendingOrders}
              expanded={pendingOrders.expanded}
              onToggle={pendingOrders.toggleExpanded}
              onCancel={pendingOrders.cancelOrder}
              cancelling={pendingOrders.cancelling}
              isSquareOffOrder={pendingOrders.isSquareOffOrder}
              stopLossOrdersCount={pendingOrders.stopLossOrdersCount}
            />
          </Box>
        )}
        {/* Configuration Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* Product Type and Order Type Selector */}
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              alignItems: "center",
            }}
          >
            {/* Product Type */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                }}
              >
                Product Type
              </Typography>
              <Tabs
                value={product}
                onChange={(e, newValue) => setProduct(newValue)}
                variant="fullWidth"
                sx={{
                  "& .MuiTabs-flexContainer": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    borderRadius: 3,
                    p: 0.25,
                  },
                  "& .MuiTabs-indicator": { display: "none" },
                }}
              >
                {getProductOptions().map((option) => (
                  <Tab
                    key={option}
                    value={option}
                    disableRipple
                    disabled={props.is_modify}
                    sx={{
                      borderRadius: 2,
                      fontSize: "0.7rem",
                      minHeight: 32,
                      height: 32,
                      padding: "4px 8px",
                      color:
                        product === option
                          ? "#FFFFFF !important" // Explicitly set to white with !important
                          : theme.palette.text.primary,
                      backgroundColor:
                        product === option
                          ? (() => {
                              switch (option) {
                                case "MIS":
                                  return theme.palette.success.main;
                                case "CNC":
                                  return theme.palette.success.dark;
                                case "NRML":
                                  return theme.palette.success.main;
                                default:
                                  return theme.palette.success.main;
                              }
                            })()
                          : "transparent",
                      "&:hover": {
                        backgroundColor:
                          product === option
                            ? (() => {
                                switch (option) {
                                  case "MIS":
                                    return theme.palette.success.main;
                                  case "CNC":
                                    return theme.palette.success.dark;
                                  case "NRML":
                                    return theme.palette.success.main;
                                  default:
                                    return theme.palette.success.main;
                                }
                              })()
                            : alpha(theme.palette.primary.main, 0.2),
                        color: "#FFFFFF !important", // White text on hover with !important
                      },
                    }}
                    label={(() => {
                      if (option === "MIS") return "Intraday";
                      if (option === "CNC" || option === "NRML")
                        return "Overnight";
                      return option;
                    })()}
                  />
                ))}
              </Tabs>
            </Box>

            {/* Order Type */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                }}
              >
                Order Type
              </Typography>
              <Tabs
                value={orderType}
                onChange={(e, newValue) => {
                  const currentPrice = props.is_modify
                    ? props.payload?.price || props.price || initialLTP.current
                    : initialLTP.current;

                  setOrderType(newValue);

                  switch (newValue) {
                    case "MARKET":
                      handlePriceChange({ target: { value: "0" } });
                      handleTriggerChange({ target: { value: "0" } });
                      break;
                    case "STOPLOSSMARKET":
                      handlePriceChange({ target: { value: "0" } });
                      handleTriggerChange({
                        target: { value: currentPrice?.toString() || "0" },
                      });
                      break;
                    case "SL":
                      handlePriceChange({
                        target: { value: currentPrice?.toString() || "0" },
                      });
                      handleTriggerChange({
                        target: { value: currentPrice?.toString() || "0" },
                      });
                      break;
                    case "LIMIT":
                      handlePriceChange({
                        target: { value: currentPrice?.toString() || "0" },
                      });
                      handleTriggerChange({ target: { value: "0" } });
                      break;
                  }
                }}
                variant="fullWidth"
                sx={{
                  "& .MuiTabs-flexContainer": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    borderRadius: 3,
                    p: 0.25,
                  },
                  "& .MuiTabs-indicator": { display: "none" },
                }}
              >
                {radioTypeOptions.map((option) => (
                  <Tab
                    key={option.value}
                    value={option.value}
                    disableRipple
                    sx={{
                      borderRadius: 2,
                      fontSize: "0.7rem",
                      minHeight: 32,
                      height: 32,
                      padding: "4px 8px",
                      color:
                        orderType === option.value
                          ? "#FFFFFF !important" // Explicitly set to white with !important
                          : theme.palette.text.primary,
                      backgroundColor:
                        orderType === option.value
                          ? (() => {
                              switch (option.value) {
                                case "MARKET":
                                  return theme.palette.success.main;
                                case "LIMIT":
                                  return theme.palette.success.dark;
                                case "SL":
                                  return theme.palette.success.main;
                                case "STOPLOSSMARKET":
                                  return theme.palette.success.dark;
                                default:
                                  return theme.palette.success.main;
                              }
                            })()
                          : "transparent",
                      "&:hover": {
                        backgroundColor:
                          orderType === option.value
                            ? (() => {
                                switch (option.value) {
                                  case "MARKET":
                                    return theme.palette.success.main;
                                  case "LIMIT":
                                    return theme.palette.success.main;
                                  case "SL":
                                    return theme.palette.success.main;
                                  case "STOPLOSSMARKET":
                                    return theme.palette.success.main;
                                  default:
                                    return theme.palette.success.main;
                                }
                              })()
                            : alpha(theme.palette.primary.main, 0.2),
                        color: "#FFFFFF !important", // White text on hover with !important
                      },
                    }}
                    label={
                      option.value === "MARKET"
                        ? "Market"
                        : option.value === "LIMIT"
                        ? "Limit"
                        : option.value === "SL"
                        ? "SL"
                        : option.value === "STOPLOSSMARKET"
                        ? "SL Market"
                        : option.label
                    }
                  />
                ))}
              </Tabs>
            </Box>
          </Box>

          {/* Quantity, Price, and Trigger Price Inputs */}
          <Grid container spacing={1}>
            {!isMobile ? (
              <>
                <Grid item xs={12} container spacing={1}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Quantity"
                      type="number"
                      value={quantity}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const sanitizedValue = inputValue.replace(/^0+/, "");

                        if (
                          sanitizedValue === "" ||
                          /^\d+$/.test(sanitizedValue)
                        ) {
                          handleQuantityChange({
                            target: {
                              value: sanitizedValue || "0",
                              name: e.target.name,
                            },
                          });
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e" || e.key === "E") {
                          e.preventDefault();
                        }
                        handleQuantityKeyDown(e);
                      }}
                      error={quantityError || (minQuantityError && !isSquareOff)}
                      helperText={
                        quantityError 
                          ? `Invalid quantity` 
                          : ""
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ mr: 1 }}
                            >
                              Qty
                            </Typography>
                          </InputAdornment>
                        ),
                        inputProps: {
                          step: props.exchange === "MCX" ? 1 : props.lotsize,
                          min: props.exchange === "MCX" ? 1 : props.lotsize,
                          style: {
                            textAlign: "left",
                            fontWeight: "bold",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: (quantityError || (minQuantityError && !isSquareOff))
                              ? theme.palette.error.main
                              : alpha(theme.palette.text.secondary, 0.3),
                          },
                          "&:hover fieldset": {
                            borderColor: (quantityError || (minQuantityError && !isSquareOff))
                              ? theme.palette.error.dark
                              : theme.palette.primary.main,
                          },
                        },
                      }}
                    />
                    {minQuantityError && !isSquareOff && (
                      <Box 
                        sx={{ 
                          mt: 0.5, 
                          px: 1, 
                          py: 0.5, 
                          backgroundColor: alpha(theme.palette.error.light, 0.1),
                          borderRadius: 1,
                          border: `1px dashed ${alpha(theme.palette.error.main, 0.3)}`,
                        }}
                      >
                        <Typography variant="caption" color="error" display="block" fontWeight="medium">
                          Min. Purchase Amount: {formatCurrency(minimumOrderValue)}
                        </Typography>
                        <Typography variant="caption" color="error" display="block" fontWeight="medium">
                          Min. Quantity: {minimumQtyRequired}
                        </Typography>
                        {/* {(orderType === "MARKET" || orderType === "STOPLOSSMARKET") && (
                          <Typography variant="caption" color="text.secondary" display="block">
                            Based on current market price: {formatCurrency(orderSide === "BUY" ? marketData.bestAsk || marketData.ltp : marketData.bestBid || marketData.ltp)}
                          </Typography>
                        )} */}
                      </Box>
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Price"
                      type="number"
                      value={price || ""}
                      onChange={handlePriceChange}
                      onKeyDown={handlePriceKeyDown}
                      error={priceError}
                      helperText={
                        priceError
                          ? `Value must be a multiple of tick_size (${props.tick_size})`
                          : ""
                      }
                      disabled={
                        orderType === "MARKET" || orderType === "STOPLOSSMARKET"
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ mr: 1 }}
                            >
                              ₹
                            </Typography>
                          </InputAdornment>
                        ),
                        inputProps: {
                          step: props.tick_size,
                          min: 0,
                          style: {
                            textAlign: "left",
                            fontWeight: "bold",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: theme.palette.text.disabled,
                          fontWeight: "bold",
                          backgroundColor: alpha(
                            theme.palette.action.disabledBackground,
                            0.1
                          ),
                          borderRadius: 1,
                          opacity: 0.7,
                          cursor: "not-allowed",
                          textDecoration: "line-through",
                        },
                        "& .MuiOutlinedInput-root.Mui-disabled": {
                          "& > fieldset": {
                            borderColor: alpha(
                              theme.palette.text.disabled,
                              0.3
                            ),
                            borderStyle: "dashed",
                            borderWidth: 1,
                          },
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: priceError
                              ? theme.palette.error.main
                              : alpha(theme.palette.text.secondary, 0.3),
                          },
                          "&:hover fieldset": {
                            borderColor: priceError
                              ? theme.palette.error.dark
                              : theme.palette.primary.main,
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sx={{ mb: 1 }}>
                  <TextField
                    fullWidth
                    label="Quantity"
                    type="number"
                    value={quantity}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.replace(/^0+/, "");

                      if (
                        sanitizedValue === "" ||
                        /^\d+$/.test(sanitizedValue)
                      ) {
                        handleQuantityChange({
                          target: {
                            value: sanitizedValue || "0",
                            name: e.target.name,
                          },
                        });
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e" || e.key === "E") {
                        e.preventDefault();
                      }
                      handleQuantityKeyDown(e);
                    }}
                    error={quantityError || (minQuantityError && !isSquareOff)}
                    helperText={
                      quantityError 
                        ? `Invalid quantity` 
                        : ""
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ mr: 1 }}
                          >
                            Qty
                          </Typography>
                        </InputAdornment>
                      ),
                      inputProps: {
                        step: props.exchange === "MCX" ? 1 : props.lotsize,
                        min: props.exchange === "MCX" ? 1 : props.lotsize,
                        style: {
                          textAlign: "left",
                          fontWeight: "bold",
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: (quantityError || (minQuantityError && !isSquareOff))
                            ? theme.palette.error.main
                            : alpha(theme.palette.text.secondary, 0.3),
                        },
                        "&:hover fieldset": {
                          borderColor: (quantityError || (minQuantityError && !isSquareOff))
                            ? theme.palette.error.dark
                            : theme.palette.primary.main,
                        },
                      },
                    }}
                  />
                  {minQuantityError && !isSquareOff && (
                    <Box 
                      sx={{ 
                        mt: 0.5, 
                        mb: 1,
                        px: 1, 
                        py: 0.5, 
                        backgroundColor: alpha(theme.palette.error.light, 0.1),
                        borderRadius: 1,
                        border: `1px dashed ${alpha(theme.palette.error.main, 0.3)}`,
                        width: '100%'
                      }}
                    >
                      <Typography variant="caption" color="error" display="block" fontWeight="medium">
                      Min. Purchase Amount: {formatCurrency(minimumOrderValue)}
                      </Typography>
                      <Typography variant="caption" color="error" display="block" fontWeight="medium">
                        Min. Quantity: {minimumQtyRequired}
                      </Typography>
                      {/* {(orderType === "MARKET" || orderType === "STOPLOSSMARKET") && (
                        <Typography variant="caption" color="text.secondary" display="block">
                          Based on current market price: {formatCurrency(orderSide === "BUY" ? marketData.bestAsk || marketData.ltp : marketData.bestBid || marketData.ltp)}
                        </Typography>
                      )} */}
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sx={{ my: 1 }}>
                  <TextField
                    fullWidth
                    label="Price"
                    type="number"
                    value={price || ""}
                    onChange={handlePriceChange}
                    onKeyDown={handlePriceKeyDown}
                    error={priceError}
                    helperText={
                      priceError
                        ? `Value must be a multiple of tick_size (${props.tick_size})`
                        : ""
                    }
                    disabled={
                      orderType === "MARKET" || orderType === "STOPLOSSMARKET"
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ mr: 1 }}
                          >
                            ₹
                          </Typography>
                        </InputAdornment>
                      ),
                      inputProps: {
                        step: props.tick_size,
                        min: 0,
                        style: {
                          textAlign: "left",
                          fontWeight: "bold",
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: theme.palette.text.disabled,
                        fontWeight: "bold",
                        backgroundColor: alpha(
                          theme.palette.action.disabledBackground,
                          0.1
                        ),
                        borderRadius: 1,
                        opacity: 0.7,
                        cursor: "not-allowed",
                        textDecoration: "line-through",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        "& > fieldset": {
                          borderColor: alpha(theme.palette.text.disabled, 0.3),
                          borderStyle: "dashed",
                          borderWidth: 1,
                        },
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: priceError
                            ? theme.palette.error.main
                            : alpha(theme.palette.text.secondary, 0.3),
                        },
                        "&:hover fieldset": {
                          borderColor: priceError
                            ? theme.palette.error.dark
                            : theme.palette.primary.main,
                        },
                      },
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          p: isMobile ? 1.5 : 1.5,
          borderTop: 1,
          borderColor: "divider",
          mt: "auto",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: isMobile ? 1 : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: isMobile ? "100%" : "auto",
            gap: 0.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Required: 
              <Typography 
                component="span" 
                variant="body2" 
                fontWeight="medium"
                color={isLowMargin && requiredMargin > 0 ? "error.main" : "text.primary"}
                sx={{ ml: 0.5 }}
              >
                ₹{requiredMargin.toFixed(2)}
              </Typography>
            </Typography>
          </Box>
          
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Available: 
              <Typography 
                component="span" 
                variant="body2" 
                fontWeight="bold"
                color={isLowMargin && requiredMargin > 0 ? "error.main" : "success.main"}
                sx={{ ml: 0.5 }}
              >
                {balanceData.formatted.availableCash}
              </Typography>
            </Typography>
            <Tooltip title="Refresh funds">
              <IconButton 
                size="small" 
                onClick={handleRefreshFunds}
                sx={{ 
                  ml: 0.5,
                  width: 24,
                  height: 24,
                  p: 0,
                }}
                disabled={loadingFunds}
              >
                <RefreshIcon 
                  fontSize="small" 
                  sx={{ 
                    fontSize: '1rem',
                    animation: loadingFunds ? 'spin 1s linear infinite' : 'none',
                    '@keyframes spin': {
                      '0%': {
                        transform: 'rotate(0deg)',
                      },
                      '100%': {
                        transform: 'rotate(360deg)',
                      },
                    },
                  }} 
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 1,
            width: isMobile ? "100%" : "auto",
            mt: isMobile ? 1 : 0,
          }}
        >
          {!isMobile && (
            <>
              {/* Add bookmark icon as a standalone button with menu */}
              {props?.formattedWatchlists && props?.formattedWatchlists?.length > 0 && (
                <Box sx={{ position: 'relative' }}>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      // Check if instrument is already in any marketwatch
                      const isInAnyWatchlist = props?.formattedWatchlists?.some(watchlist => 
                        watchlist.instruments?.some(
                          instr => instr.token == props.token && instr.exchange === props.exchange
                        )
                      );
                      
                      if (isInAnyWatchlist) {
                        // If already in a watchlist, show menu to select which one to remove from
                        setAnchorEl(e.currentTarget);
                      } else {
                        // If not in any watchlist, show menu to select which one to add to
                        setAnchorEl(e.currentTarget);
                      }
                    }}
                    sx={{
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 1,
                      p: 0.25,
                      minWidth: 32,
                      height: 28,
                      backgroundColor: 'background.paper',
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                      }
                    }}
                  >
                    {props?.formattedWatchlists?.some(watchlist => 
                      watchlist.instruments?.some(
                        instr => instr.token == props.token && instr.exchange === props.exchange
                      )
                    ) ? (
                      <BookmarkIcon 
                        fontSize="small" 
                        sx={{ 
                          color: theme.palette.success.main,
                        }} 
                      />
                    ) : (
                      <BookmarkBorderIcon 
                        fontSize="small" 
                        sx={{ 
                          color: theme.palette.text.secondary,
                        }} 
                      />
                    )}
                  </IconButton>
                  
                  {/* Menu for selecting marketwatch */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    PaperProps={{
                      sx: {
                        maxHeight: 300,
                        width: 250,
                        mt: 1,
                        boxShadow: theme.shadows[4]
                      }
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 600 }}>
                      {props?.formattedWatchlists?.some(watchlist => 
                        watchlist.instruments?.some(
                          instr => instr.token == props.token && instr.exchange === props.exchange
                        )
                      ) ? 'Remove from Marketwatch' : 'Add to Marketwatch'}
                    </Typography>
                    <Divider />
                    {props?.formattedWatchlists?.map((watchlist, index) => {
                      const isInWatchlist = watchlist.instruments?.some(
                        instr => instr.token == props.token && instr.exchange == props.exchange
                      );
                      
                      return (
                        <MenuItem 
                          key={watchlist.id}
                          onClick={() => {
                            if (isInWatchlist) {
                              // Remove from this watchlist
                              handleRemoveFromMarketwatch(watchlist, index);
                            } else {
                              // Add to this watchlist
                              handleAddToMarketwatch(watchlist, index);
                            }
                            setAnchorEl(null);
                          }}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            py: 1
                          }}
                        >
                          <Typography variant="body2">
                            {watchlist.name}
                          </Typography>
                          {isInWatchlist && (
                            <BookmarkIcon 
                              fontSize="small" 
                              sx={{ color: theme.palette.success.main, ml: 1 }} 
                            />
                          )}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                </Box>
              )}
              
              {isLowMargin && requiredMargin > 0 && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleAddFundsClick}
                  sx={{ 
                    textTransform: 'none',
                    fontSize: '0.75rem',
                    py: 0.25,
                    height: 28,
                  }}
                >
                  Add Funds
                </Button>
              )}
              
              <Button
                onClick={handleClose}
                variant="outlined"
                size="small"
                sx={{ minWidth: 80, height: 28, fontSize: '0.8rem' }}
              >
                Cancel
              </Button>
            </>
          )}
          <Button
            onClick={(e) => {
              e.stopPropagation();
              if (is_modify) {
                handleModify(e);
              } else {
                handleSubmit(e);
              }
            }}
            variant="contained"
            size={isMobile ? "large" : "small"}
            disabled={
              // If it's a square-off operation, disable if loading, funds insufficient, or pending orders exist (but not for modify operations)
              isSquareOff ? (loading || 
                           (availableMargin < requiredMargin && requiredMargin > 0) ||
                           (!is_modify && pendingOrders.instrumentPendingOrders && pendingOrders.instrumentPendingOrders.length > 0)) : 
              // Normal case: full validation
              (loading || isDisabled || (availableMargin < requiredMargin && requiredMargin > 0) || 
               (minQuantityError && !isSquareOff))
            }
            fullWidth={isMobile}
            sx={{
              backgroundColor:
                orderSide === "BUY" ? "success.main" : "error.main",
              "&:hover": {
                backgroundColor:
                  orderSide === "BUY" ? "success.dark" : "error.dark",
              },
              height: isMobile ? 'auto' : 28,
              fontSize: isMobile ? 'inherit' : '0.8rem',
            }}
          >
            {loading
              ? "Placing Order..."
              : props.is_modify
              ? `Modify ${orderSide}`
              : orderSide}
          </Button>
          
          {/* Add Funds button for mobile */}
          {isMobile && isLowMargin && requiredMargin > 0 && (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<AddIcon />}
              onClick={handleAddFundsClick}
              sx={{ 
                textTransform: 'none',
                fontSize: '0.75rem',
                py: 0.5,
                mt: 1,
                width: '100%',
              }}
            >
              Add Funds
            </Button>
          )}
          
          {/* Add bookmark icon for mobile with menu */}
          {isMobile && props?.formattedWatchlists && props?.formattedWatchlists?.length > 0 && (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              mt: 1,
              p: 1,
              borderRadius: 1,
              backgroundColor: alpha(theme.palette.background.paper, 0.5),
              border: `1px solid ${theme.palette.divider}`
            }}>
              <Box 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 1,
                  cursor: 'pointer'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  // Open the mobile dialog for selecting marketwatch
                  setMobileDialogOpen(true);
                }}
              >
                {props?.formattedWatchlists.some(watchlist => 
                  watchlist.instruments?.some(
                    instr => instr.token == props.token && instr.exchange === props.exchange
                  )
                ) ? (
                  <>
                    <BookmarkIcon 
                      fontSize="small" 
                      sx={{ color: theme.palette.success.main }} 
                    />
                    <Typography variant="body2" color="text.secondary">
                      In Marketwatch - Tap to manage
                    </Typography>
                  </>
                ) : (
                  <>
                    <BookmarkBorderIcon 
                      fontSize="small" 
                      sx={{ color: theme.palette.text.secondary }} 
                    />
                    <Typography variant="body2" color="text.secondary">
                      Add to Marketwatch
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          )}
          
          {/* Mobile Dialog for selecting marketwatch */}
          <Dialog
            open={mobileDialogOpen}
            onClose={() => setMobileDialogOpen(false)}
            fullWidth
            maxWidth="xs"
            PaperProps={{
              sx: {
                borderRadius: 2,
                maxHeight: '70vh'
              }
            }}
          >
            <DialogTitle>
              {props?.formattedWatchlists?.some(watchlist => 
                watchlist.instruments?.some(
                  instr => instr.token == props.token && instr.exchange === props.exchange
                )
              ) ? 'Manage Marketwatch' : 'Add to Marketwatch'}
              <IconButton
                aria-label="close"
                onClick={() => setMobileDialogOpen(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <List sx={{ pt: 0 }}>
                {props?.formattedWatchlists?.map((watchlist, index) => {
                  const isInWatchlist = watchlist.instruments?.some(
                    instr => instr.token == props.token && instr.exchange === props.exchange
                  );
                  
                  return (
                    <ListItem 
                      key={watchlist.id}
                      button
                      onClick={() => {
                        if (isInWatchlist) {
                          // Remove from this watchlist
                          handleRemoveFromMarketwatch(watchlist, index);
                        } else {
                          // Add to this watchlist
                          handleAddToMarketwatch(watchlist, index);
                        }
                      }}
                      sx={{
                        borderRadius: 1,
                        mb: 0.5,
                        backgroundColor: isInWatchlist ? alpha(theme.palette.success.main, 0.1) : 'transparent'
                      }}
                    >
                      <ListItemText 
                        primary={watchlist.name} 
                        primaryTypographyProps={{
                          fontWeight: isInWatchlist ? 600 : 400
                        }}
                      />
                      {isInWatchlist ? (
                        <BookmarkIcon 
                          fontSize="small" 
                          sx={{ color: theme.palette.success.main }} 
                        />
                      ) : (
                        <BookmarkBorderIcon 
                          fontSize="small" 
                          sx={{ color: theme.palette.text.secondary }} 
                        />
                      )}
                    </ListItem>
                  );
                })}
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setMobileDialogOpen(false)}>
                Done
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </DialogActions>
    </Dialog>
  );
});

OrderWindow.displayName = "OrderWindow";

export default OrderWindow;
